import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span
              className={`text-lg md:text-xl font-bold transition-colors duration-300 ${
                isScrolled ? "text-foreground-950" : "text-white"
              }`}
              style={{ fontFamily: "var(--font-heading)" }}
            >
              佐佐木希
            </span>
            <span
              className={`hidden md:inline text-xs transition-colors duration-300 ${
                isScrolled ? "text-foreground-600" : "text-white/70"
              }`}
            >
              Nozomi Sasaki
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                isActive("/")
                  ? isScrolled
                    ? "bg-primary-500 text-background-50"
                    : "bg-white/20 text-white"
                  : isScrolled
                    ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                    : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive(`/category/${cat.slug}`)
                    ? isScrolled
                      ? "bg-primary-500 text-background-50"
                      : "bg-white/20 text-white"
                    : isScrolled
                      ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                      : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                isActive("/about")
                  ? isScrolled
                    ? "bg-primary-500 text-background-50"
                    : "bg-white/20 text-white"
                  : isScrolled
                    ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                    : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full transition-colors ${
              isScrolled
                ? "text-foreground-950"
                : "text-white"
            }`}
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMobileMenuOpen ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive("/")
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive(`/category/${cat.slug}`)
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive("/about")
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}